$(document).ready(function() {

    changeExchangeToArab = function(chars) {
    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
        for (var i = 0; i < chars.length; i++) {
            if (parseFloat(chars[i]) > -1) {
                chars[i] = arabicNumbers[chars[i]];
            }
        }
        return chars.join('');
    }
    
    changeExchangeToLatin = function(arabic_number) {
    	try {
            var array_arab = arabic_number.split("");
            for (var i = 0; i < array_arab.length; i++) {
                switch (array_arab[i]) {
                    case "۰":
                    	array_arab[i] = "0";
                        break;
                    case "۱":
                    	array_arab[i] = "1";
                        break;
                    case "۲":
                    	array_arab[i] = "2";
                        break;
                    case "۳":
                    	array_arab[i] = "3";
                        break;
                    case "٤":
                    	array_arab[i] = "4";
                        break;
                    case "٥":
                    	array_arab[i] = "5";
                        break;
                    case "٦":
                    	array_arab[i] = "6";
                        break;
                    case "۷":
                    	array_arab[i] = "7";
                        break;
                    case "۸":
                    	array_arab[i] = "8";
                        break;
                    case "۹":
                    	array_arab[i] = "9";
                        break;
                    case ".":
                    	array_arab[i] = ".";
                        break;
                    case ",":
                        break;
                    default:
                    	array_arab[i] = arabic_number[i];
                }
            }
            return array_arab.join('');
        } catch (e) {
            return arabic_number
        }
    }
    
	if(document.querySelector('#arabFromAmount') != null){
	setTimeout(function(){
	
		console.log("Arabic Currency converter initialized");
		
		document.getElementById('arabFromAmount').addEventListener("keyup", function(){
			arabInputFrom(event);
			console.log("keydown on arabFromInput");
		});
		
		document.getElementById('arabToAmount').addEventListener("keyup", function(){
			arabInputTo(event);
			console.log("keydown on arabToInput");
		});
		
		$("[data-currency=fromAmountCurrency]").on("change", function(){
			latinToArabInputFrom(event);
			console.log("keydown on arabFromInput");
		});
		
		$("[data-currency=toAmountCurrency]").on("change", function(){
			latinToArabInputTo(event);
			console.log("keydown on arabToInput");
		});

		function latinToArabInputFrom(e) {
			console.log("Event on arabFromInput dispatched");
			if (e.which != 8) {
				e.preventDefault();
			    };
			    conversionFromLatinToArab(e);
			  }
		
		function arabInputFrom(e) {
			console.log("Event on arabFromInput dispatched");
			if (e.which != 8) {
				e.preventDefault();
			    };
			    conversionFrom(e);
			  }
		
		
		function arabInputTo(e) {
			console.log("Event on arabToInput dispatched");
			if (e.which != 8) {
				e.preventDefault();
			    };
			    conversionTo(e);
			  }
		
		function latinToArabInputTo(e) {
			console.log("Event on arabToInput dispatched");
			if (e.which != 8) {
				e.preventDefault();
			    };
			    conversionToLatinToArab(e);
			  }

		function conversionFromLatinToArab(e) {
			console.log("Conversion on arabFromInput");
			var text = e.keyCode;
			var arabFromAmount = document.getElementById('arabFromAmount');
			var latinFromAmount = document.getElementById('transformFrom');
			    
			var transformTo = document.getElementById('transformTo');
			var arabToAmount = document.getElementById('arabToAmount');
				
			console.log(e.keyCode);
			
			arabFromAmount.setAttribute("num", latinFromAmount.value.toString());
			arabFromAmount.value = changeExchangeToArab(latinFromAmount.value.toString().split(""));


			arabToAmount.value = changeExchangeToArab(transformTo.value.toString().split(""));
		}
		
		function conversionFrom(e) {
			console.log("Conversion on arabFromInput");
			var text = e.keyCode;
			var arabFromAmount = document.getElementById('arabFromAmount');
			var latinFromAmount = document.getElementById('transformFrom');
			    
			var transformTo = document.getElementById('transformTo');
			var arabToAmount = document.getElementById('arabToAmount');
				
			console.log(e.keyCode);
			
			arabFromAmount.setAttribute("num", changeExchangeToLatin(arabFromAmount.value.toString()));
			if(isNaN(Number(changeExchangeToLatin(arabFromAmount.value)))){
				arabFromAmount.value = "";
			}
			arabFromAmount.value = changeExchangeToArab(arabFromAmount.value.toString().split(""));

			latinFromAmount.value = parseFloat(arabFromAmount.getAttribute("num"));
			$("#transformFrom" ).trigger( "change" );
			arabToAmount.value = changeExchangeToArab(transformTo.value.toString().split(""));
		}

		function conversionToLatinToArab(e) {
			console.log("Conversion on arabToInput");
			var text = e.keyCode;
			
			var arabToAmount = document.getElementById('arabToAmount');
			var transformTo = document.getElementById('transformTo');
			

			var transformFrom = document.getElementById('transformFrom');
			var arabFromAmount = document.getElementById('arabFromAmount');

			console.log(e.keyCode);

			arabToAmount.setAttribute("num", transformTo.value.toString());
			arabToAmount.value = changeExchangeToArab(transformTo.value.toString().split(""));

			arabFromAmount.value = changeExchangeToArab(transformFrom.value.toString().split(""));
		}
		
		function conversionTo(e) {
			console.log("Conversion on arabToInput");
			var text = e.keyCode;
			
			var arabToAmount = document.getElementById('arabToAmount');
			var transformTo = document.getElementById('transformTo');
			

			var transformFrom = document.getElementById('transformFrom');
			var arabFromAmount = document.getElementById('arabFromAmount');

			console.log(e.keyCode);

			arabToAmount.setAttribute("num", changeExchangeToLatin(arabToAmount.value.toString()));
			if(isNaN(Number(changeExchangeToLatin(arabToAmount.value)))){
				arabToAmount.value = "";
			}
			arabToAmount.value = changeExchangeToArab(arabToAmount.value.toString().split(""));

			transformTo.value = parseFloat(arabToAmount.getAttribute("num"));
			$("#transformTo" ).trigger( "change" );
			arabFromAmount.value = changeExchangeToArab(transformFrom.value.toString().split(""));
		}

	}, 1500);
	}
});